#import "@core/schema/fragments/PublicSubscriptionFull.graphql"

mutation (
  $input: SubscriptionInput!
) {
  createSubscription(
    input: $input
  ) {
    ...PublicSubscriptionFull
  }
}
